import { inject, Injectable, signal } from '@angular/core';
import { ToastType } from '../toast.component.types';
import { TranslateService } from '@ngx-translate/core';

interface ToastProps {
  title: string;
  description: string;
  type: ToastType;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private isVisibleWritable = signal(false);
  private titleWritable = signal<string>('');
  private descriptionWritable = signal<string>('');
  private typeWritable = signal<ToastType>('default');

  private readonly translateService = inject(TranslateService);

  public readonly isVisible = this.isVisibleWritable.asReadonly();
  public readonly title = this.titleWritable.asReadonly();
  public readonly description = this.descriptionWritable.asReadonly();
  public readonly type = this.typeWritable.asReadonly();

  public show({ title, description, type }: ToastProps) {
    this.titleWritable.set(title);
    this.descriptionWritable.set(description);
    this.typeWritable.set(type);
    this.isVisibleWritable.set(true);
  }

  public hide() {
    this.isVisibleWritable.set(false);
  }

  public showGenericError(message?: string) {
    this.show({
      title: this.translateService.instant('toast-generic-error-title'),
      description: message || this.translateService.instant('toast-generic-error-description'),
      type: 'error',
    });
  }
}
